import { Component, OnInit } from '@angular/core';
import { CarsService } from 'src/app/services/cars.service';
import { PaymentService } from 'src/app/services/payment.service';
import { RentingService } from 'src/app/services/renting.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';

@Component({
  selector: 'app-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss']
})
export class TilesComponent implements OnInit {

  public nbLocation:number|string="00";
  public nbPaiement: number|string="00";
  public nbUser:number|string="00";
  public nbCar: number|string="00";

  constructor(
    private locationService:RentingService,
    private paiementService:PaymentService,
    private userService:UserServiceService,
    private carService:VehiculeserviceService,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData()
  {
    this.locationService.indexAll().subscribe((res:any)=>{
      console.log(res);
       if(res.rentings.length >0)
        this.nbLocation = res.rentings.length <=9?'0'+res.rentings.length:res.rentings.length;
       else  
        this.nbLocation = "00";
    })

    this.paiementService.index().subscribe((res:any)=>{
      console.log(res)
      if(res.paiements.length >0)
        this.nbPaiement = res.paiements.length <=9?'0'+res.paiements.length:res.paiements.length;
       else  
        this.nbPaiement = "00";
    })

    this.userService.getUser().subscribe((res:any)=>{
      if(res.length >0)
        this.nbUser = res.length <=9?'0'+res.length:res.length;
      else  
        this.nbUser = "00";
    })

    this.carService.getallvehicleAdmin().subscribe((res:any)=>{
      if(res.length >0)
        this.nbCar = res.length <=9?'0'+res.length:res.length;
      else  
      this.nbCar = "00";
    })
  }

}
